<template>
    <div>
        <div class="left-toolbar mb10">
            <button @click="exportPdf" class="swb-btn-small swb-btn">导出为pdf</button>
            <button @click="exportExcel" class="swb-btn-small swb-btn">导出为EXCEL</button>
            <template v-if="goodsOrderMapInfo.origFileGenerated == false" >
                <button  style="float: right;" @click="genEsignFile" class="swb-btn-small swb-btn">生成待签署PDF文件</button>
            </template>
            <template v-else>
                <button style="float: right;" @click="downloadEsignFile(goodsOrderMapInfo.origFileUuid)" class="swb-btn-small swb-btn">下载待签署PDF文件</button>
            </template>


        </div>
        <div id="goodOrderInfoPdf">
            <div style="font-size: 15px; color: #1a1a1a; font-weight: 600; text-align: center; padding: 15px 0;">
            <span v-if="goodsOrderMapInfo.buyerBizUnitName != goodsOrderMapInfo.buyerComName">{{ goodsOrderMapInfo.buyerBizUnitName }}-
                {{ goodsOrderMapInfo.buyerComName }}<span v-if="goodsOrderMapInfo.contractId != null">{{ goodsOrderMapInfo.contractTitle }}</span>购销订单/验收单
            </span>
                <span v-else>
                {{ goodsOrderMapInfo.buyerBizUnitName }}<span v-if="goodsOrderMapInfo.contractId != null">{{ goodsOrderMapInfo.contractTitle }}</span>购销订单/验收单
            </span>
            </div>
            <table class="simple-tbl" style="width:100%;table-layout: fixed;border-collapse: collapse;border-spacing: 2px;border-color: gray;color: #666;font-size:10px; word-break:break-strict;">
                <tbody class="body">
                <tr class="row">
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: left;color: #1a1a1a;font-size:10px;">
                        <span>甲方公司</span>
                    </td>
                    <td colspan="3" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: left;color: #1a1a1a;font-size:10px;">
                        <span>{{ goodsOrderMapInfo.buyerRealComName }}</span>
                    </td>
                    <td colspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: left;color: #1a1a1a;font-size:10px;">
                        <span>门店名称</span>
                    </td>
                    <td colspan="3" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: left;color: #1a1a1a;font-size:10px;">
                        <span>{{ goodsOrderMapInfo.buyerComName }}</span>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: left;color: #1a1a1a;font-size:10px;">
                        <span>订货单号</span>
                    </td>
                    <td colspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: left;color: #1a1a1a;font-size:10px;">
                        <span>{{ goodsOrderMapInfo.orderNo }}</span>
                    </td>
                </tr>
                <tr class="row">
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: left;color: #1a1a1a;font-size:10px;">
                        <span>乙方公司</span>
                    </td>
                    <td colspan="3" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: left;color: #1a1a1a;font-size:10px;">
                        <span>{{ goodsOrderMapInfo.sellerName }}</span>
                    </td>
                    <td colspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: left;color: #1a1a1a;font-size:10px;">
                        <span>乙方联系人</span>
                    </td>
                    <td colspan="3" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: left;color: #1a1a1a;font-size:10px;">
                        <span>{{ goodsOrderMapInfo.sellerComContactName }}</span>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: left;color: #1a1a1a;font-size:10px;">
                        <span>订购日期</span>
                    </td>
                    <td colspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: left;color: #1a1a1a;font-size:10px;">
                        <span>{{ goodsOrderMapInfo.submitTime }}</span>
                    </td>
                </tr>
                <tr class="row">
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: left;color: #1a1a1a;font-size:10px;">
                        <span>供商编号</span>
                    </td>
                    <td colspan="3" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: left;color: #1a1a1a;font-size:10px;">
                        <span v-if="goodsOrderMapInfo.sellerInnerCode != null">{{ goodsOrderMapInfo.sellerInnerCode }}</span>
                        <span v-else>{{ goodsOrderMapInfo.sellerNo }}</span>
                    </td>
                    <td colspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: left;color: #1a1a1a;font-size:10px;">
                        <span>乙方联系电话</span>
                    </td>
                    <td colspan="3" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: left;color: #1a1a1a;font-size:10px;">
                        <span>{{ goodsOrderMapInfo.sellerComContactTel }}</span>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: left;color: #1a1a1a;font-size:10px;">
                        <span>到货日期</span>
                    </td>
                    <td colspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: left;color: #1a1a1a;font-size:10px;">
                        <span>{{ goodsOrderMapInfo.desireArriveDate }}</span>
                    </td>
                </tr>
                <tr class="row" v-if="goodsOrderMapInfo.goodsOrderItemList != null && goodsOrderMapInfo.goodsOrderItemList.length > 0">
                    <td rowspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span>序号</span>
                    </td>
                    <td rowspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span>规格编码</span>
                    </td>
                    <td rowspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span>产品名称</span>
                    </td>
                    <td rowspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span>规格</span>
                    </td>
                    <td rowspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span>单位</span>
                    </td>
                    <td rowspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span>数量</span>
                    </td>
                    <td rowspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span>未税单价</span>
                    </td>
                    <td rowspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span>含税单价<br/>
                            <span v-if="goodsOrderMapInfo.taxRate != null">({{ goodsOrderMapInfo.taxRate }}%)</span>
                            <span v-else-if="goodsOrderMapInfo.taxRate == null && goodsOrderMapInfo.goodsOrderItemList != null && goodsOrderMapInfo.goodsOrderItemList.length > 0">({{ goodsOrderMapInfo.goodsOrderItemList[0].taxRate }}%)</span>
                        </span>
                    </td>
                    <td rowspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span>含税总价</span>
                    </td>
                    <td rowspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span>备注</span>
                    </td>
                    <td colspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span>验收明细</span>
                    </td>
                </tr>
                <tr class="row" v-if="goodsOrderMapInfo.goodsOrderItemList != null && goodsOrderMapInfo.goodsOrderItemList.length > 0">
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span>验收数量</span>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span>验收金额</span>
                    </td>
                </tr>
                <tr class="row" v-for="(itemInfo, index) in goodsOrderMapInfo.goodsOrderItemList">
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span wbr="true">{{ index + 1 }}</span>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span wbr="true">{{ itemInfo.assetDefCode || '' }}</span>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span wbr="true">{{ itemInfo.title }}</span>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span wbr="true">{{ itemInfo.fixedSpec }}</span>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span>{{ itemInfo.unit }}</span>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span wbr="true">{{ itemInfo.quantity || 0 }}</span>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span wbr="true" v-if="itemInfo.ntxPrice != null">{{ itemInfo.ntxPrice.toFixed(2) }}</span>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span wbr="true" v-if="itemInfo.price != null">{{ itemInfo.price.toFixed(2) }}</span>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span wbr="true" v-if="itemInfo.amount != null">{{ itemInfo.amount.toFixed(2) }}</span>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: left;color: #1a1a1a;font-size:10px;">
                        <span wbr="true">{{ itemInfo.desc || '' }}</span>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span wbr="true"></span>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span wbr="true"></span>
                    </td>
                </tr>
                <tr class="row">
                    <td colspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;background-color: #efefef;font-size:10px;">
                        <span>合计（小写）</span>
                    </td>
                    <td colspan="7" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: right;color: #1a1a1a;background-color: #efefef;font-size:10px;">
                        <span wbr="true" v-if="goodsOrderMapInfo.totalAmont != null">{{ goodsOrderMapInfo.totalAmont.toFixed(2) }}元</span>
                        <span v-else>0.00元</span>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;background-color: #efefef;font-size:10px;">
                        <span></span>
                    </td>
                    <td rowspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;background-color: #efefef;font-size:10px;">
                        <span></span>
                    </td>
                    <td rowspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;background-color: #efefef;font-size:10px;">
                        <span></span>
                    </td>
                </tr>
                <tr class="row">
                    <td colspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;background-color: #efefef;font-size:10px;">
                        <span>产品总价（大写）</span>
                    </td>
                    <td colspan="7" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: right;color: #1a1a1a;background-color: #efefef;font-size:10px;">
                        <span wbr="true" v-if="goodsOrderMapInfo.totalAmontChsMoneyStr != null">{{ goodsOrderMapInfo.totalAmontChsMoneyStr }}</span>
                        <span v-else>零元整</span>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;background-color: #efefef;font-size:10px;">
                        <span></span>
                    </td>
                </tr>
                <tr class="row">
                    <td colspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span>设备送货地址</span>
                    </td>
                    <td colspan="7" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: left;color: #1a1a1a;font-size:10px;">
                        <span>{{ goodsOrderMapInfo.buyerComAddress }}</span>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span></span>
                    </td>
                    <td colspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: left;color: #1a1a1a;font-size:10px;">
                        <span></span>
                    </td>
                </tr>
                <tr class="row">
                    <td colspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span>接货联系人及电话</span>
                    </td>
                    <td colspan="3" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: left;color: #1a1a1a;font-size:10px;">
                        <span>{{ goodsOrderMapInfo.buyerComContactName }}&nbsp;{{ goodsOrderMapInfo.buyerComContactTel }}</span>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span>实际到<br/>货日期</span>
                    </td>
                    <td colspan="3" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: left;color: #1a1a1a;font-size:10px;">
                        <span wbr="true">{{ goodsOrderMapInfo.receiveDate || '' }}</span>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span>接货情况</span>
                    </td>
                    <td colspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: left;color: #1a1a1a;font-size:10px;">
                        <span></span>
                    </td>
                </tr>
                <tr class="row">
                    <td colspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span>付款方式</span>
                    </td>
                    <td colspan="10" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: left;color: #1a1a1a;font-size:10px;">
                        <span>货到验收合格后三个月支付{{ goodsOrderMapInfo.amountPayPct || 0 }}%；</span>
                    </td>
                </tr>
                <tr class="row">
                    <td colspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span>验收方式</span>
                    </td>
                    <td colspan="10" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: left;color: #1a1a1a;font-size:10px;">
                        <span>根据年采合同验收标准，现场由厂家送货人员、店铺资产管理员或后勤主管及店总三方签字进行验收（以实际验收数量及金额进行费用结算）,经甲方盖章及资产采购人员签字后方为有效。</span>
                    </td>
                </tr>
                <tr class="row">
                    <td colspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span>保险/运输/其他</span>
                    </td>
                    <td colspan="10" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: left;color: #1a1a1a;font-size:10px;">
                        <span>乙方负责设备的全部保险，乙方负责包装及全部运费，其它各项相关条款均执行年采合同条款。</span>
                    </td>
                </tr>
                <tr class="row" valign="top">
                    <td colspan="6" style="border: 1px solid #1a1a1a;padding: 10px 4px;text-align: left;color: #1a1a1a;font-size:10px;height: 150px;">
                        <span style="float: left; line-height: 120px;">甲方盖章：</span>
                    </td>
                    <td colspan="6" style="border: 1px solid #1a1a1a;padding: 10px 4px;text-align: left;color: #1a1a1a;font-size:10px;height: 150px;">
                        <span style="float: left; line-height: 120px;">乙方盖章：</span>
                    </td>
                </tr>
                <tr class="row">
                    <td colspan="6" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: left;color: #1a1a1a;font-size:10px;">
                        <div>甲方法人/委托人代理签字：</div>
                        <div>甲方签署日期：</div>
                    </td>
                    <td colspan="6" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: left;color: #1a1a1a;font-size:10px;">
                        <div>乙方法人/委托人代理签字：</div>
                        <div>乙方签署日期：</div>
                    </td>
                </tr>
                <tr class="row">
                    <td rowspan="4" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span>使用部门<br/>验收意见</span>
                    </td>
                    <td colspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span>*设备状况是否正常</span>
                    </td>
                    <td colspan="3" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span>是：□</span>
                        <span style="margin-left: 5px">否：□</span>
                    </td>
                    <td colspan="3" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span>*施工是否安全文明</span>
                    </td>
                    <td colspan="3" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span>是：□</span>
                        <span style="margin-left: 5px">否：□</span>
                    </td>
                </tr>
                <tr class="row">

                    <td colspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span>*附属配件是否齐全</span>
                    </td>
                    <td colspan="3" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span>是：□</span>
                        <span style="margin-left: 5px">否：□</span>
                    </td>
                    <td colspan="3" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span>*垃圾清理是否及时</span>
                    </td>
                    <td colspan="3" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span>是：□</span>
                        <span style="margin-left: 5px">否：□</span>
                    </td>
                </tr>
                <tr class="row">

                    <td colspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span>*外观形状是否符合</span>
                    </td>
                    <td colspan="3" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span>是：□</span>
                        <span style="margin-left: 5px">否：□</span>
                    </td>
                    <td colspan="3" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span>*来货设备是否闲置</span>
                    </td>
                    <td colspan="3" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span>是：□</span>
                        <span style="margin-left: 5px">否：□</span>
                    </td>
                </tr>
                <tr class="row">
                    <td colspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span>设备质量问题</span>
                    </td>
                    <td colspan="9" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span></span>
                    </td>
                </tr>
                <tr class="row">
                    <td rowspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span>确认签字</span>
                    </td>
                    <td colspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span>*资产管理员/维修课长（日期）</span>
                    </td>
                    <td colspan="3" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span></span>
                    </td>
                    <td colspan="3" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span>*供应商（日期）</span>
                    </td>
                    <td colspan="3" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span></span>
                    </td>
                </tr>
                <tr class="row">
                    <td colspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span>*店总/负责人（日期）</span>
                    </td>
                    <td colspan="3" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span></span>
                    </td>
                    <td colspan="3" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span>*资产采购</span>
                    </td>
                    <td colspan="3" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size:10px;">
                        <span></span>
                    </td>
                </tr>
                <tr class="row">
                    <td colspan="12" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: left;color: #1a1a1a;font-size:10px;">
                        <span>注：带*为必填项<br/>*1.验收必须经甲方资产采购人员签字确认后方为有效验收单。<br/>2.本订单签署单价为未税金额、乙方需提供税务机关认可的13%增值税专用发票，如国家统一调整税率，即按调整后税率执行，未税金额不变。<br/>3.本订单一式肆份，双方各执贰份，应明确写明验收数量、验收金额、验收日期；未约定或约定不明的，按双方签订的年采合同执行。</span>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { Utils } from '../../app.base'
import { Vue, MsgBox, Routes } from '../../app.vues'
import { showHtmlToPdfDlg } from '../ctrl/dialog'
//
import goodsOrderApi from '../../api/goodsOrder'

export default {
    name: 'swb-goods-order-info-for-pdf',
    desc: '商品订单签名文件PDF下载数据',
    props: ['goodsOrderId'],
    data: function () {
        return {
            goodsOrderMapInfo: {}
        }
    },
    created: function () {
        //
        this.getDataInfo();
    },
    methods: {
        getDataInfo: function () {
            let self = this;
            let postData = {};
            postData.id = this.goodsOrderId;
            let msgBoxDlg = MsgBox.loading();
            goodsOrderApi.getGoodsOrderInfoForDownloadPdf(postData, function (result) {
                msgBoxDlg.close();
                if(result.type == "info") {
                    self.goodsOrderMapInfo = result.data;
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        exportPdf: function () {
            let result = $("#goodOrderInfoPdf").html() || '';
            showHtmlToPdfDlg("商品订单PDF打印", result, null);
        },
        exportExcel: function () {

            // this.$fileDownloader.post(this.url);

            Utils.setPageUrl(getAppUrl("/api/goods/order/info/for/download/excel/get?id=" + this.goodsOrderId), '_blank');

            // let self = this;
            // let postData = {};
            // postData.id = this.goodsOrderId;
            // let msgBoxDlg = MsgBox.loading();
            // goodsOrderApi.getGoodsOrderInfoForDownloadExcel(postData, function (result) {
            //     msgBoxDlg.close();
            //     if(result.type == "info") {
            //         //
            //     } else {
            //         MsgBox.warning(result.message);
            //     }
            // });
        },

        genEsignFile: function() {
            let fileName = "商品订单" + this.goodsOrderMapInfo.orderNo + '.pdf';
            let pdfHtml = $("#goodOrderInfoPdf").html() || '';
            let params = {
                id: this.goodsOrderMapInfo.id,
                fileName: fileName,
                htmpContext: pdfHtml
            }

            let self = this;
            self.$confirm('确定要生成待签署文件吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                let msgBoxDlg = MsgBox.loading();
                goodsOrderApi.genGoodsOrderOrigFile(params, function(result) {
                    msgBoxDlg.close()
                    if(result.type == 'info') {
                        MsgBox.info('生成成功')
                        self.getDataInfo()
                    } else {
                        MsgBox.warning(result.message)
                    }
                })
            });
        },
        downloadEsignFile: function(fileUuid) {
            if(fileUuid) {
                Utils.downloadFile(getAppUrl("/file/download?uuid=" + fileUuid));
            } else {
                MsgBox.warning('文件uuid异常');
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/compo/order/GoodsOrderInfoForPdf.vue